<template>
  <div>
    <ValidationProvider
        :name="formRow.name"
        :rules="rules"
        v-slot="{ passed, failed }"
    >
      <md-field>
        <label>{{ $t(formRow.title) }}</label>
        <md-select v-model="obj[formRow.name]">
          <md-option
              v-for="option in formRow.choice_options"
              :key="option.value"
              :value="option.value"
          >
            {{ $t(option.text) }}
          </md-option>
        </md-select>
      </md-field>
      <p v-if="failed" style="text-align: left;">
        <b v-if="formRow.attr.validations" class="text-danger">{{
            formRow.attr.validations[0].message
          }}</b>
      </p>
    </ValidationProvider>
  </div>
</template>
<script>
import {extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";

extend("required", required);

export default {
  name: "SelectList",
  props: {
    objeto: {
      type: Object,
      default: function () {
        return {};
      },
      require: true
    },
    formRow: {
      type: Object,
      default: function () {
        return {};
      },
      require: true
    },
    field_index: {
      type: Number,
      default: -1,
      required: false
    }
  },
  data() {
    return {
      selectedItem: null,
      selectedItems: [],
      fieldValue: this.value,
      obj: this.objeto,
      rules: ""
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.formRow) {
        if (this.formRow.attr.validations && this.formRow.attr.validations.length > 0) {
          this.rules = "required";
        }
        if (this.formRow.attr["default-value"] && !this.obj[this.formRow.name]) {
          this.obj[this.formRow.name] = this.formRow.attr["default-value"];
        }
      }
    }
  },
};
</script>
